import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider, Descriptions, Input, Select, Radio, Flex, Checkbox } from 'antd';
import { BaseContainer } from 'components/containers';
import { Editor, ConfirmButton, ListButton } from 'components/elements';
import { Upload } from 'pages/common';
import { getBoardTypeAPI, postBoardTaskAPI } from 'api/board';
import { boardAuthOptions, productDisplayStatusOptions } from 'data/options';
import { URL_ADMIN } from 'routes/AdminRoute';
import { URL_BOARD_TASK, URL_BOARD_TASK_DETAIL } from 'routes/CommonRoute';
import { BaseSection } from 'components/layouts';

const BoardTaskAdd = () => {
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [value, setValue] = useState({
    read_authority: '1',
    display_yn: 1,
    board_type: 1,
    fixing_top_yn: 0
  });
  const [loading, setLoading] = useState(false)

  const fnUpload = (v) => {
    const fileName = []
    const filePath = []
    v?.map(it => {
      if (it?.file_path) {
        fileName.push(it?.origin_file_name)
        filePath.push(it?.file_path)
      }
    })
    setValue({
      ...value,
      attached_file: fileName,
      attached_file_path: filePath
    })
  }

  const fnAddBoardTask = async () => {
    setLoading(true)
    try {
      if (!value?.title) {
        alert('제목을 입력해주세요.')
        return false
      }
      if (!value?.content) {
        alert('내용을 입력해주세요.')
        return false
      }
      const body = { ...value }
      const { data } = await postBoardTaskAPI(body)
      const { idx } = data
      alert('등록되었습니다.')
      navigate(`${URL_ADMIN}${URL_BOARD_TASK_DETAIL.replace(':no', idx)}`)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  };

  const fnGetBoardType = async () => {
    try {
      const { data } = await getBoardTypeAPI()
      const { data_list } = data
      const cate = data_list?.map(it => ({
        value: it?.BOARD_TYPE,
        label: it?.BOARD_TYPE_NAME
      }))
      setCategory(cate)
    } catch (err) {
      console.error(err)
    }
  }

  const fnHandleAdd = useCallback((v) => {
    setValue((value) => ({
      ...value,
      ...v
    }));
  }, []);

  useEffect(() => {
    fnGetBoardType();
  }, []);

  const items = [
    { key: '1', label: <span className='text-require'>열람권한</span>, children: <Radio.Group value={value?.read_authority} options={boardAuthOptions} onChange={(e) => fnHandleAdd({ read_authority: e.target.value })} /> },
    { key: '2', label: <span className='text-require'>노출여부</span>, children: <Radio.Group value={value?.display_yn} options={productDisplayStatusOptions} onChange={(e) => fnHandleAdd({ display_yn: e.target.value })} /> },
    { key: '3', label: <span className='text-require'>카테고리</span>, children: <Select value={value?.board_type} style={{ width: '16rem' }} options={category} onSelect={(v) => fnHandleAdd({ board_type: v })} /> },
    { key: '4', label: '상단고정', children: <Checkbox checked={value?.fixing_top_yn} onChange={(e) => fnHandleAdd({ fixing_top_yn: e.target.checked ? 1 : 0 })} /> },
    { key: '5', span: 2, label: <span className='text-require'>제목</span>, children: <Input value={value?.title} onChange={(e) => fnHandleAdd({ title: e.target.value })} /> },
    { key: '6', label: '첨부파일', children: <Upload inputSize={'300px'}  data={[]} onChange={fnUpload} /> }
  ];

  return (
    <BaseSection>
      <BaseContainer>
        <Descriptions bordered column={2} labelStyle={{ width: '16rem' }} contentStyle={{ textAlign: 'left' }} items={items} />
        <Divider className="divider-small" />
        <Editor data={value?.content} onChange={(v) => fnHandleAdd({ content: v })} />
        <Divider className="divider" />

        <Flex justify={'end'} gap={3}>
          <ConfirmButton loading={loading} label="작성완료" onClick={fnAddBoardTask} />
          <ListButton onClick={() => navigate(`${URL_ADMIN}${URL_BOARD_TASK}`)} />
        </Flex>
      </BaseContainer>
    </BaseSection>
  );
};

export default BoardTaskAdd;
